import { render, staticRenderFns } from "./face.vue?vue&type=template&id=615fa827&scoped=true&"
import script from "./face.vue?vue&type=script&lang=js&"
export * from "./face.vue?vue&type=script&lang=js&"
import style0 from "./face.vue?vue&type=style&index=0&id=615fa827&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fa827",
  null
  
)

export default component.exports